import React from 'react';

import styles from './LabelWithIcon.module.scss';

const LabelWithIcon = ({ tag, img, varient, customStyles, onDelete, deleteIcon }) => (
  <div className={`${styles.labelContainer} ${varient} ${customStyles}`}>
    {img ? <img className={styles.labelIconImg} src={img} alt={`${tag} icon`} /> : null}
    <div className={styles.textStyles}>{tag}</div>
    {onDelete && (
      <button type="button" onClick={onDelete} className={styles.iconButton}>
        {deleteIcon}
      </button>
    )}
  </div>
);

export default LabelWithIcon;
